import type {ModsLoader, ModsLoaderConstructor} from './modsLoader';
import {createDefaultLogger} from '@libs/logger';
import Alert from '@libs/sweetalert';

export default class ModsLoadersRepository {
    private readonly modsLoaders: Record<string, ModsLoader> = {};

    registerLoader(loaderConstructor: ModsLoaderConstructor): void {
        if (!loaderConstructor) {
            throw new Error('Loader module is missing default export');
        }

        const loader = new loaderConstructor(
            createDefaultLogger,
            Alert,
        );

        if (!loader?.name || !loader?.getPaths) {
            throw new Error(`Invalid mod loader: ${JSON.stringify(loader)}`);
        }

        if (loader.name in this.modsLoaders) {
            throw new Error(`Loader with name '${loader.name}' already exists.`);
        }

        this.modsLoaders[loader.name] = loader;
    }

    getLoaders(): ModsLoader[] {
        return Object.values(this.modsLoaders);
    }
}
